import { DiscountGroupType } from "@redotech/redo-model/discount";
import { z } from "zod";
import { redoDiscountSchema } from "./discount-schemas";

export const getDiscountsByTeam = {
  input: z.object({ groupType: z.nativeEnum(DiscountGroupType).optional() }),
  output: z.array(redoDiscountSchema),
};
